module.exports = __webpack_public_path__ + "img/9788971250150.8e6b11b3.jpg";